Vue.component("downloadLink", {
    mixins: [SceneContentComponentMixin],
    template: `
        <div class="downloadLink">
        </div>
    `,
    data() {
        return {
            downloadUrl: ''
        }
    },
    methods: {
        openDownload(url) {
            //download
            var win = window.open(url, '_blank');
            win.focus();
            
            //close self
            let currentScene = this.$route.path.split(':')
            this.$router.push(currentScene[0])
        }
    },
    computed: {},
    mounted() {
        // download when opened
        this.openDownload(this.downloadUrl);
    },
})

touchKit.ComponentManager.register("downloadLink", {
    singleton: true
});